import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';
export const AdminRoute = ({ children }) => {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
    const token = useAuthStore((state) => state.token);
    const tenant = useAuthStore((state) => state.tenant);
    if (!isAuthenticated || !token) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    if (!tenant || typeof tenant.isAdmin !== 'boolean') {
        return _jsx("div", { className: "min-h-screen bg-[#0C0C0E]" });
    }
    if (!tenant?.isAdmin) {
        return _jsx(Navigate, { to: "/dashboard", replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
